module.exports = __webpack_public_path__ + "img/Icon-Notes-grey.806fcfd1.svg";